// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PaymentProviderLocation from './view'

export default function PaymentProviderLocationFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PaymentProvider/PaymentProviderLocation">
      <PaymentProviderLocation {...props}>
        {children}
      </PaymentProviderLocation>
    </Flow>
  )
}
